import { render } from "./aCardWaveItem.vue?vue&type=template&id=50cd9654"
import script from "./aCardWaveItem.vue?vue&type=script&lang=js"
export * from "./aCardWaveItem.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__